module.exports = __webpack_public_path__ + "img/Garment.1c4ca448.jpg";